import React, { ReactElement } from 'react'

import './vertical-header.scss'
import { Hero } from '@which/seatbelt'

interface Props {
  image: string
  intro: string
  title: string
  standFirst: string
}

const VerticalHeader = ({ image, intro, title, standFirst }: Props): ReactElement => {
  return (
    <div className="vertical-header" data-testid="vertical-header">
      <Hero description={intro} image={{ src: image }} title={title} standfirst={standFirst} />
    </div>
  )
}

export default VerticalHeader
